const formatter = (phone: string) => {
  let result = "";
  for (let i = 0; i < phone.length; i++) {
    (Number(phone[i]) || phone[i] === "0") && (result = result + phone[i]);
  }
  return result;
};

export default formatter;
